<template>
  <v-card v-if="currentTag" flat outlined>
    <v-card-title class="text-h5">
      <v-text-field
        :autofocus="true"
        :color="getTagColor(currentTag.color)"
        v-model="currentTag.name"
        label="Namn"
        outlined
      ></v-text-field>
    </v-card-title>

    <v-card-subtitle>
      <v-textarea
        outlined
        auto-grow
        rows="3"
        label="Beskrivning"
        v-model="currentTag.description"
        hide-details
        :color="getTagColor(currentTag.color)"
      ></v-textarea>
    </v-card-subtitle>
    <div class="mb-2">
      <div class="color-label">Färg på taggen</div>
      <div class="color-options">
        <ColorOption
          v-for="(key, i) in Object.keys(tagColors)"
          :key="i"
          :color="tagColors[key]"
          @change="onSelectColor"
          :selected="currentTag.color === key"
        />
      </div>
    </div>
    <v-alert v-if="deleteEnabled" dense type="error" class="mx-4 mt-5">
      Om du raderar taggen så försvinner den från alla kontakter som har den.
    </v-alert>
    <v-card-actions>
      <v-switch
        v-if="!isNewTag"
        v-model="deleteEnabled"
        label="Radera taggen"
        hide-details
        color="red"
      ></v-switch>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="onDelete" :loading="loading" v-if="deleteEnabled">Radera</v-btn>
      <v-btn color="primary" @click="onSave" :loading="loading" v-if="!deleteEnabled">Spara</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { tagColors, getTagColor } from '@/assets/data/colors.js'
import ColorOption from '@/components/contacts/ColorOption.vue'
export default {
  name: 'EditTag',
  props: {
    tag: Object,
    loading: Boolean,
  },
  components: {
    ColorOption,
  },
  data() {
    return {
      currentTag: { id: null, name: '', description: '', color: 'COLOR_1' },
      deleteEnabled: false,
      tagColors,
    }
  },
  watch: {
    tag: {
      handler: function (tag) {
        if (!tag) return
        this.currentTag = tag.color ? tag : { ...tag, color: 'COLOR_1' }
      },
      immediate: true,
      deep: true,
    },
    loading: {
      handler: function (val) {
        if (!val) {
          this.deleteEnabled = false
        }
      },
      immediate: true,
    },
  },
  computed: {
    isNewTag() {
      return !this.currentTag.id
    },
    currentTagColor() {
      return getTagColor(this.currentTag.color)
    },
  },
  methods: {
    getTagColor,
    onSave() {
      this.$emit('save', this.currentTag)
    },
    onDelete() {
      this.$emit('delete', this.currentTag)
    },
    onSelectColor(colorValue) {
      const colorCode = Object.keys(tagColors).find((key) => tagColors[key] === colorValue)
      this.currentTag = { ...this.currentTag, color: colorCode }
    },
  },
}
</script>

<style lang="less" scoped>
.color-options {
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  gap: 14px;
}
.color-label {
  padding-left: 16px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
}
</style>
